import {
    isAbTestControl,
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';
import { PAGEVIEW_LIMIT_FLOW } from '../authModal/authentication/authFlowConstants';
import { gaLabels } from '../authModal/postAuth/constants';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import { getEverLoggedIn } from 'dibs-cookie-jar';

const REGISTRATION_MODAL_REDESIGN = 'REGISTRATION_MODAL_REDESIGN';

const isRegistrationModalControl =
    typeof window !== 'undefined'
        ? isAbTestControl(document.cookie, REGISTRATION_MODAL_REDESIGN)
        : false;
const isRegistrationModalVariant =
    typeof window !== 'undefined'
        ? isAbTestVariant(document.cookie, REGISTRATION_MODAL_REDESIGN)
        : false;

const fireRegistrationModalABTestTracking = eventLabel => {
    const action = `registration_${eventLabel}`;
    const trackingData = getAbTestTrackingData(document.cookie, REGISTRATION_MODAL_REDESIGN);
    tracking.trackAbTestEvent(trackingData, action);
};

const isRegistrationModalTestLimitFlow = flowName =>
    isRegistrationModalVariant && flowName === PAGEVIEW_LIMIT_FLOW;

const isRegistrationModalTestLimitLaunchOrigin = launchOrigin =>
    isRegistrationModalVariant && launchOrigin === gaLabels.PAGEVIEW_LIMIT_REACHED;

const shouldFireRegistrationModalTestTracking = () => {
    const visitCountModel = new VisitCountModel();
    return (
        visitCountModel.get('totalVisitCount') === 1 &&
        !getEverLoggedIn(document.cookie) &&
        (isRegistrationModalControl || isRegistrationModalVariant)
    );
};

export {
    isRegistrationModalTestLimitFlow,
    isRegistrationModalTestLimitLaunchOrigin,
    isRegistrationModalVariant,
    isRegistrationModalControl,
    fireRegistrationModalABTestTracking,
    shouldFireRegistrationModalTestTracking,
};
